import React from 'react'

const UpdateSessionForm = () => {
  return (
    <div>UpdateSessionForm</div>
  )
}

export default UpdateSessionForm